import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=24b72bf2&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=24b72bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b72bf2",
  null
  
)

export default component.exports